var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ yuntuColor: _vm.yuntuColor }},[_c('div',{class:[_vm.isActiveClass || _vm.activeLoginBtn ? 'activeClass' : 'disableClass'],attrs:{"id":"sendButton"},on:{"click":function($event){return _vm.sendCodeBtn()}}},[_c('p',{staticClass:"sendCode"},[_vm._v(_vm._s(_vm.buttonText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }